class SliderBlock {
  /**
   * Add custom JavaScript to the block HTML.
   *
   * @param   Element  block       The block element
   * @param   object   attributes  The block attributes (only available when editing)
   * @return  void
   */
  constructor(block, attributes = null) {
    this.block = block;
    this.sliderContainer = block.querySelector('.slider__container');

    new Swiper(this.sliderContainer, {
      autoHeight: true,
      speed: 400,
      slidesPerView: 1,
      centeredSlides: true,
      navigation: {
        nextEl: '.slider__slider-nav-button--next',
        prevEl: '.slider__slider-nav-button--prev',
        disabledClass: 'slider__slider-nav-button--disabled',
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
      },
      keyboard: {
        enabled: true,
      },
      threshold: 1,
    });
  }
}

// Initialize each block on page load (front end)
document.querySelectorAll('.slider').forEach((block) => {
  new SliderBlock(block);
});

// Initialize the dynamic block preview (editor)
if (window.acf) {
  window.acf.addAction('render_block_preview/type=slider', ($block, attributes) => {
    new SliderBlock($block.find('.slider').get(0), attributes);
  });
}